export const getCurrencySymbol = (currency: string, amount: number) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: currency,
  }).format(amount);
};
